import React from 'react';
import { cn } from '@/shared/lib/utils';

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: keyof React.JSX.IntrinsicElements;
}

export const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  ({ className, as = 'div', ...props }, ref) => {
    const Component = as as any;
    return (
      <Component
        ref={ref}
        className={cn('box-border', className)}
        {...props}
      />
    );
  }
);

Box.displayName = 'Box';